<template>
  <div class="newdetail_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ data.title }}
      </div>
    </div>
    <div class="ctn">
      <h1 class="article-title">
        {{ data.title }}
      </h1>
      <!-- <vue-editor v-model="data.content" style="display: none"/> -->
      <div
        class="contract_box"
        v-html="data.content"
      />
    </div>
  </div>
</template>

<script>

    import Fetch from "../../utils/fetch";
	import bsHeader from '../../components/bsHeader.vue'

    export default {
        name: "Aritcle",
        components: {bsHeader},
        data() {
            return {
                data: {},
            };
        },
        created() {
            this.$parent.footer('user',false);
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/index/article_detail', {
                    id: this.$router.history.current.params.code
                }).then(res => {
                    this.data = res.data;
                })
            },
        }
    };
</script>

<style lang="less" scoped>
.newdetail_wrap {
  box-sizing: border-box;
  min-height: 100vh;
  overflow-x: hidden;
  padding-bottom: 40px;
  background: #f7f5f7 url('../images/ban1/ppbg.png') no-repeat center 50px / 100% auto;
}

.red_top_bg {
  height: 50px;
  background: linear-gradient(110deg, #ff4d72, #e31c5f 60%, #bd1e59);
  box-shadow: 0 8px 22px rgba(189, 30, 89, .14);

  .big_tit {
    top: 0;
    width: calc(100% - 108px);
    height: 50px;
    overflow: hidden;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 50px;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.back_left {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 44px;
  height: 50px;
  margin: 0;
  background-size: 14px auto;
  cursor: pointer;
}

.ctn {
  box-sizing: border-box;
  width: calc(100% - 12px);
  margin: 10px 6px 0;
  padding: 10px 20px 30px;
  border: 1px solid #f1e8ed;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(50, 28, 42, .07);
}

.article-title {
  margin: 0 0 18px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f1edf0;
  color: #27232a;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.45;
  word-break: break-word;
}

.contract_box {
  overflow-wrap: anywhere;
  color: #49434b;
  font-size: 14px;
  line-height: 1.8;
}

.contract_box /deep/ img,
.contract_box /deep/ video,
.contract_box /deep/ iframe {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.contract_box /deep/ table {
  display: block;
  max-width: 100%;
  overflow-x: auto;
}

.contract_box /deep/ a {
  color: #d82162;
}
</style>
